import type {FabricObject} from '@postermywall/fabricjs-2';
import {Textbox} from '@postermywall/fabricjs-2';

/**
 * A body the pointer cannot drag: fully movement-locked (the page background, or an item the user
 * locked), and not a textbox mid-edit — an editing textbox owns the pointer for text selection.
 * Desktop turns such a press into a marquee; touch turns it into a canvas pan.
 */
export const isMovementLockedBody = (fabricObject: FabricObject): boolean => {
  const isEditingText = fabricObject instanceof Textbox && fabricObject.isEditing;
  return fabricObject.lockMovementX && fabricObject.lockMovementY && !isEditingText;
};
